import { z } from 'zod';

import { MatchingRecord } from '@eluve/utils';

import { MedicalCodeTypesEnum } from './types';

export const MedicalCodeTypesLookup = {
  CPT: 'CPT',
  ICD_10: 'ICD_10',
  SNOMED: 'SNOMED',
  HCPCS: 'HCPCS',
} as const satisfies MatchingRecord<MedicalCodeTypesEnum>;

export const DiagnosticMedicalCodeTypes: string[] = [
  MedicalCodeTypesLookup.ICD_10,
  MedicalCodeTypesLookup.SNOMED,
];

export const ProceduralMedicalCodeTypes: string[] = [
  MedicalCodeTypesLookup.CPT,
  MedicalCodeTypesLookup.HCPCS,
];

export const AllMedicalCodeTypes: MedicalCodeTypesEnum[] = [
  ...(DiagnosticMedicalCodeTypes as MedicalCodeTypesEnum[]),
  ...(ProceduralMedicalCodeTypes as MedicalCodeTypesEnum[]),
];

export const MedicalCodeTypesSchema = z.nativeEnum(MedicalCodeTypesLookup);
